
import KionCard from './Card.vue'
import { mixins } from 'vue-class-component'

export default class KionSmallCard extends mixins(KionCard) {
}
